export interface Asn {
  asn: string
  name: string
  domain: string
  route: string
  type: string
}

export interface Company {
  name: string
  domain: string
  network: string
  type: string
}

export interface Language {
  name: string
  native: string
  code: string
}

export interface Currency {
  name: string
  code: string
  symbol: string
  native: string
  plural: string
}

export interface TimeZone {
  name: string
  abbr: string
  offset: string
  is_dst: boolean
  current_time: string
}

export interface Threat {
  is_tor: boolean
  is_icloud_relay: boolean
  is_proxy: boolean
  is_datacenter: boolean
  is_anonymous: boolean
  is_known_attacker: boolean
  is_known_abuser: boolean
  is_threat: boolean
  is_bogon: boolean
  blocklists: string[]
}

export interface Geolocation {
  ip: string
  is_eu: boolean
  city: string
  region: string
  region_code: string
  region_type: string
  country_name: string
  country_code: string
  continent_name: string
  continent_code: string
  latitude: number
  longitude: number
  postal: string
  calling_code: string
  flag: string
  emoji_flag: string
  emoji_unicode: string
  asn: Asn
  company: Company
  languages: Language[]
  currency: Currency
  time_zone: TimeZone
  threat: Threat
  count: string
}

export const nonSaasCountryCodes = ['AU', 'IE', 'NZ', 'SG', 'MY', 'HK', 'MX']

export const globalCountryCodes = [
  'AE',
  'AT',
  'BE',
  'BG',
  'CA',
  'CH',
  'CO',
  'CY',
  'CZ',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'DE',
  'GB',
  'GR',
  'IT',
  'IN',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'SE',
  'US',
  'BR',
]
